<template>
  <div class="layout" />
</template>

<script>
export default {
  mixins: [],
  data () {
    return {
    };
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-back.scss";

.layout {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
</style>
